var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRegisterImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Background_Complete"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: 382.398,
    style: {
      fill: "#EBEBEB"
    },
    width: 500,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.779,
    y: 398.494,
    style: {
      fill: "#EBEBEB"
    },
    width: 33.122,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.527,
    y: 401.208,
    style: {
      fill: "#EBEBEB"
    },
    width: 8.693,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.586,
    y: 389.208,
    style: {
      fill: "#EBEBEB"
    },
    width: 19.192,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.459,
    y: 390.888,
    style: {
      fill: "#EBEBEB"
    },
    width: 43.193,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.556,
    y: 390.888,
    style: {
      fill: "#EBEBEB"
    },
    width: 6.333,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.471,
    y: 395.111,
    style: {
      fill: "#EBEBEB"
    },
    width: 93.676,
    height: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M237.014,337.8H43.915c-3.147,0-5.708-2.561-5.708-5.708V60.66c0-3.147,2.561-5.708,5.708-5.708 h193.099c3.146,0,5.707,2.561,5.707,5.708v271.432C242.721,335.239,240.16,337.8,237.014,337.8z M43.915,55.203 c-3.01,0-5.458,2.448-5.458,5.458v271.432c0,3.01,2.448,5.458,5.458,5.458h193.099c3.009,0,5.457-2.448,5.457-5.458V60.66 c0-3.009-2.448-5.458-5.457-5.458H43.915z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M453.31,337.8H260.212c-3.147,0-5.707-2.561-5.707-5.708V60.66c0-3.147,2.561-5.708,5.707-5.708 H453.31c3.148,0,5.708,2.561,5.708,5.708v271.432C459.019,335.239,456.458,337.8,453.31,337.8z M260.212,55.203 c-3.009,0-5.457,2.448-5.457,5.458v271.432c0,3.01,2.448,5.458,5.457,5.458H453.31c3.01,0,5.458-2.448,5.458-5.458V60.66 c0-3.009-2.448-5.458-5.458-5.458H260.212z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 100.355,
    y: 173.877,
    style: {
      fill: "#F0F0F0"
    },
    width: 141.985,
    height: 208.169
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 105.374,
    y: 180.43,
    style: {
      fill: "#E0E0E0"
    },
    width: 131.947,
    height: 38.447
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.374,
    y: 186.654,
    style: {
      fill: "#EBEBEB"
    },
    width: 7.495,
    height: 32.223
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.617,
    y: 186.654,
    style: {
      fill: "#EBEBEB"
    },
    width: 7.496,
    height: 32.223
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185.553,
    y: 186.252,
    transform: "matrix(0.9855 -0.1698 0.1698 0.9855 -31.6201 35.0923)",
    style: {
      fill: "#EBEBEB"
    },
    width: 7.496,
    height: 32.223
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.661,
    y: 190.9,
    style: {
      fill: "#EBEBEB"
    },
    width: 7.495,
    height: 27.976
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.89,
    y: 190.9,
    style: {
      fill: "#EBEBEB"
    },
    width: 7.495,
    height: 27.976
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175.376,
    y: 190.9,
    style: {
      fill: "#EBEBEB"
    },
    width: 7.495,
    height: 27.976
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.586,
    y: 190.42,
    transform: "matrix(0.9762 -0.2169 0.2169 0.9762 -40.5694 39.2118)",
    style: {
      fill: "#EBEBEB"
    },
    width: 7.496,
    height: 27.976
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.891,
    y: 185.054,
    style: {
      fill: "#EBEBEB"
    },
    width: 3.748,
    height: 33.822
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.474,
    y: 185.054,
    style: {
      fill: "#EBEBEB"
    },
    width: 3.748,
    height: 33.822
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 105.374,
    y: 224.964,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 342.6952 488.3752)",
    style: {
      fill: "#E0E0E0"
    },
    width: 131.947,
    height: 38.447
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229.826,
    y: 231.188,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 467.1472 494.5993)",
    style: {
      fill: "#EBEBEB"
    },
    width: 7.495,
    height: 32.222
  }), /*#__PURE__*/React.createElement("rect", {
    x: 193.582,
    y: 231.188,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 394.6603 494.5993)",
    style: {
      fill: "#EBEBEB"
    },
    width: 7.496,
    height: 32.222
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149.646,
    y: 230.786,
    transform: "matrix(-0.9855 -0.1698 0.1698 -0.9855 262.6272 516.2596)",
    style: {
      fill: "#EBEBEB"
    },
    width: 7.495,
    height: 32.223
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220.538,
    y: 235.435,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 448.5722 498.8456)",
    style: {
      fill: "#EBEBEB"
    },
    width: 7.496,
    height: 27.976
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.31,
    y: 235.435,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 414.1154 498.8456)",
    style: {
      fill: "#EBEBEB"
    },
    width: 7.496,
    height: 27.976
  }), /*#__PURE__*/React.createElement("rect", {
    x: 159.824,
    y: 235.435,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 327.1429 498.8456)",
    style: {
      fill: "#EBEBEB"
    },
    width: 7.496,
    height: 27.976
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180.614,
    y: 234.955,
    transform: "matrix(-0.9762 -0.2169 0.2169 -0.9762 310.3411 531.9466)",
    style: {
      fill: "#EBEBEB"
    },
    width: 7.495,
    height: 27.976
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.057,
    y: 229.589,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 431.8616 492.9995)",
    style: {
      fill: "#EBEBEB"
    },
    width: 3.748,
    height: 33.822
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.474,
    y: 229.589,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 342.6953 492.9995)",
    style: {
      fill: "#EBEBEB"
    },
    width: 3.748,
    height: 33.822
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.374,
    y: 231.188,
    style: {
      fill: "#EBEBEB"
    },
    width: 7.495,
    height: 32.222
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.661,
    y: 235.435,
    style: {
      fill: "#EBEBEB"
    },
    width: 7.495,
    height: 27.976
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.89,
    y: 235.435,
    style: {
      fill: "#EBEBEB"
    },
    width: 7.495,
    height: 27.976
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.891,
    y: 229.589,
    style: {
      fill: "#EBEBEB"
    },
    width: 3.748,
    height: 33.822
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 105.374,
    y: 269.499,
    style: {
      fill: "#E0E0E0"
    },
    width: 131.947,
    height: 38.447
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 181.107,
    y: 275.723,
    style: {
      fill: "#EBEBEB"
    },
    width: 7.496,
    height: 32.223
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225.043,
    y: 275.32,
    transform: "matrix(0.9855 -0.1698 0.1698 0.9855 -46.1743 43.0936)",
    style: {
      fill: "#EBEBEB"
    },
    width: 7.496,
    height: 32.223
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.151,
    y: 279.969,
    style: {
      fill: "#EBEBEB"
    },
    width: 7.496,
    height: 27.976
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.38,
    y: 279.969,
    style: {
      fill: "#EBEBEB"
    },
    width: 7.495,
    height: 27.976
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.866,
    y: 279.969,
    style: {
      fill: "#EBEBEB"
    },
    width: 7.496,
    height: 27.976
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194.076,
    y: 279.489,
    transform: "matrix(0.9762 -0.2169 0.2169 0.9762 -58.9471 49.8958)",
    style: {
      fill: "#EBEBEB"
    },
    width: 7.495,
    height: 27.976
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.381,
    y: 274.123,
    style: {
      fill: "#EBEBEB"
    },
    width: 3.748,
    height: 33.822
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.964,
    y: 274.123,
    style: {
      fill: "#EBEBEB"
    },
    width: 3.748,
    height: 33.822
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138.81,
    y: 275.32,
    transform: "matrix(0.9855 -0.1698 0.1698 0.9855 -47.4278 28.4477)",
    style: {
      fill: "#EBEBEB"
    },
    width: 7.496,
    height: 32.223
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.633,
    y: 279.969,
    style: {
      fill: "#EBEBEB"
    },
    width: 7.496,
    height: 27.976
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.842,
    y: 279.489,
    transform: "matrix(0.9762 -0.2169 0.2169 0.9762 -61.0001 31.1914)",
    style: {
      fill: "#EBEBEB"
    },
    width: 7.495,
    height: 27.976
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.73,
    y: 274.123,
    style: {
      fill: "#EBEBEB"
    },
    width: 3.748,
    height: 33.822
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 75.86,
    y: 173.877,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 176.2151 556.469)",
    style: {
      fill: "#E0E0E0"
    },
    width: 24.495,
    height: 208.715
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M325.437,377.144h-20.812l10.941-89.107c0.463-3.772,3.896-6.83,7.668-6.83h7.152h83.657 l-13.312,95.937H325.437z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M391.443,377.144h20.812l10.941-89.107c0.463-3.772-2.219-6.83-5.991-6.83h-7.152 c-3.772,0-7.205,3.058-7.668,6.83L391.443,377.144z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6E6"
    },
    d: "M383.776,377.039l3.771-43.099c0.168-1.925,1.656-3.472,3.573-3.717l1.551-0.198 c2.571-0.328,4.566-2.404,4.792-4.986l0.688-7.858c0.282-3.221-2.257-5.991-5.49-5.991h34.781c3.233,0,5.772,2.77,5.49,5.991 l-0.688,7.858c-0.226,2.582-2.221,4.658-4.792,4.986l-1.551,0.198c-1.917,0.245-3.404,1.792-3.572,3.717l-3.771,43.099 c-0.275,3.142-2.906,5.553-6.06,5.553h-34.781C380.87,382.592,383.501,380.181,383.776,377.039z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6E6"
    },
    d: "M288.061,323.15c-0.592-6.768-6.259-11.961-13.053-11.961h16.829h13.45 c6.794,0,12.461,5.193,13.053,11.961l2.989,34.165h-30.28L288.061,323.15z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M261.557,311.189h13.45c6.794,0,12.461,5.193,13.053,11.961l2.989,34.164h72.117l2.989-34.165 c0.592-6.768,6.259-11.961,13.053-11.961h13.45c3.233,0,5.772,2.77,5.49,5.991l-0.688,7.858 c-0.226,2.582-2.221,4.658-4.792,4.986l-1.551,0.198c-1.917,0.245-3.404,1.792-3.573,3.717l-3.771,43.099 c-0.275,3.142-2.906,5.553-6.06,5.553H276.501c-3.154,0-5.785-2.411-6.06-5.553l-3.771-43.099 c-0.168-1.925-1.656-3.472-3.572-3.717l-1.551-0.198c-2.571-0.328-4.566-2.404-4.792-4.986l-0.688-7.858 C255.785,313.96,258.324,311.189,261.557,311.189z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6E6"
    },
    d: "M102.159,163.477c0,0-1.108-7.303,4.219-11.986c5.326-4.683,4.858-7.468,3.336-7.831 c-1.522-0.363-2.927,4.319-5.268,5.607c0,0-0.074-6.673,2.304-9.131c2.378-2.458,3.626-8.791,1.363-8.903 c-2.263-0.111-2.497,3.762-2.965,6.508c-0.468,2.746-2.99,6.609-2.99,6.609s-0.492-5.971-2.029-8.429 c-1.537-2.458,2.561-8.078,0.98-10.536c-1.58-2.458-4.39,2.224-4.156,7.492c0.234,5.268,3.746,10.887,2.927,16.389 c0,0-1.549-3.863-2.94-4.214c-1.391-0.351-2.796-2.906-3.732-3.853c-0.937-0.947-2.107,2.331,0,5.375 c2.107,3.044,7.492,11.187,6.673,17.768L102.159,163.477z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6E6"
    },
    d: "M105.343,160.155l1.744,10.946c0.539,3.38-2.073,6.441-5.496,6.441h-1.861 c-3.423,0-6.035-3.061-5.496-6.441l1.744-10.946H105.343z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210.056,
    y: 152.042,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 425.5436 327.4352)",
    style: {
      fill: "#EBEBEB"
    },
    width: 5.432,
    height: 23.351
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.79,
    y: 152.042,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 373.013 327.4352)",
    style: {
      fill: "#EBEBEB"
    },
    width: 5.432,
    height: 23.351
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151.95,
    y: 151.75,
    transform: "matrix(-0.9855 -0.1698 0.1698 -0.9855 279.3288 350.7467)",
    style: {
      fill: "#EBEBEB"
    },
    width: 5.432,
    height: 23.351
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.325,
    y: 155.119,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 412.0824 330.5125)",
    style: {
      fill: "#EBEBEB"
    },
    width: 5.432,
    height: 20.274
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190.84,
    y: 155.119,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 387.1118 330.5125)",
    style: {
      fill: "#EBEBEB"
    },
    width: 5.432,
    height: 20.274
  }), /*#__PURE__*/React.createElement("rect", {
    x: 159.326,
    y: 155.119,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 324.0838 330.5125)",
    style: {
      fill: "#EBEBEB"
    },
    width: 5.432,
    height: 20.274
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174.393,
    y: 154.771,
    transform: "matrix(-0.9762 -0.2169 0.2169 -0.9762 314.2313 364.3063)",
    style: {
      fill: "#EBEBEB"
    },
    width: 5.432,
    height: 20.274
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.628,
    y: 150.883,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 399.9725 326.2759)",
    style: {
      fill: "#EBEBEB"
    },
    width: 2.716,
    height: 24.511
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166.319,
    y: 150.883,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 335.3545 326.2759)",
    style: {
      fill: "#EBEBEB"
    },
    width: 2.716,
    height: 24.511
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 120.479,
    y: 156.859,
    style: {
      fill: "#EBEBEB"
    },
    width: 26.467,
    height: 18.272
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 215.558,
    y: 164.343,
    style: {
      fill: "#EBEBEB"
    },
    width: 22.173,
    height: 13.642
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 221.46,
    y: 152.352,
    style: {
      fill: "#EBEBEB"
    },
    width: 11.087,
    height: 13.641
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 391.443,
    y: 134.303,
    style: {
      fill: "#E0E0E0"
    },
    width: 26.37,
    height: 109.885
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.366,
    y: 134.303,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 731.3485 378.7801)",
    style: {
      fill: "#E0E0E0"
    },
    width: 98.617,
    height: 110.175
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.185,
    y: 134.303,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 728.6906 378.7801)",
    style: {
      fill: "#F0F0F0"
    },
    width: 102.32,
    height: 110.175
  }), /*#__PURE__*/React.createElement("rect", {
    x: 317.556,
    y: 137.817,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 728.8553 377.2321)",
    style: {
      fill: "#FFFFFF"
    },
    width: 93.744,
    height: 101.599
  }), /*#__PURE__*/React.createElement("rect", {
    x: 317.556,
    y: 137.817,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 636.8504 377.2321)",
    style: {
      fill: "#E0E0E0"
    },
    width: 1.739,
    height: 101.599
  }), /*#__PURE__*/React.createElement("rect", {
    x: 363.902,
    y: 165.977,
    transform: "matrix(6.123234e-17 -1 1 6.123234e-17 153.0254 577.519)",
    style: {
      fill: "#E0E0E0"
    },
    width: 2.74,
    height: 92.541
  }), /*#__PURE__*/React.createElement("rect", {
    x: 317.556,
    y: 206.277,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 730.3249 417.1543)",
    style: {
      fill: "#F0F0F0"
    },
    width: 95.214,
    height: 4.6
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Background_Simple",
    style: {
      display: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ef233c"
    },
    d: "M89.369,124.198c27.919-59.449,127.059-51.062,165.317-9.255 c38.258,41.806,50.696,68.599,85.208,52.983c34.512-15.616,78.518-11.44,81.043,38.164s-37.913,108.263-102.09,125.615 c-64.177,17.352-64.161,78.759-149.1,66.368c-46.31-6.756-47.365-56.86-40.825-98.301 C135.462,258.331,56.991,193.141,89.369,124.198z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.9,
      fill: "#FFFFFF"
    },
    d: "M89.369,124.198c27.919-59.449,127.059-51.062,165.317-9.255 c38.258,41.806,50.696,68.599,85.208,52.983c34.512-15.616,78.518-11.44,81.043,38.164s-37.913,108.263-102.09,125.615 c-64.177,17.352-64.161,78.759-149.1,66.368c-46.31-6.756-47.365-56.86-40.825-98.301 C135.462,258.331,56.991,193.141,89.369,124.198z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Shadow_1_"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "_x3C_Path_x3E__359_",
    style: {
      fill: "#F5F5F5"
    },
    cx: 250,
    cy: 416.238,
    rx: 193.889,
    ry: 11.323
  })), /*#__PURE__*/React.createElement("g", {
    id: "Interface"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c9c9c9"
    },
    d: "M321.955,378.128H143.035c-4.04,0-7.316-3.275-7.316-7.316V160.14c0-4.04,3.275-7.316,7.316-7.316 h178.919c4.04,0,7.316,3.275,7.316,7.316v210.672C329.271,374.852,325.995,378.128,321.955,378.128z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    d: "M321.955,378.128H143.035c-4.04,0-7.316-3.275-7.316-7.316 V160.14c0-4.04,3.275-7.316,7.316-7.316h178.919c4.04,0,7.316,3.275,7.316,7.316v210.672 C329.271,374.852,325.995,378.128,321.955,378.128z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 167.077,
    y: 256.147,
    style: {
      fill: "#FFFFFF"
    },
    width: 130.837,
    height: 22.403
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M178.776,269.528v0.587h-4.54v-6.42h4.402v0.587h-3.723v2.284h3.32v0.577h-3.32v2.385H178.776z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M179.694,267.346h2.403v0.568h-2.403V267.346z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M191.515,267.318v2.797h-0.651v-2.733c0-1.018-0.514-1.54-1.385-1.54 c-0.99,0-1.614,0.642-1.614,1.742v2.531h-0.651v-2.733c0-1.018-0.514-1.54-1.394-1.54c-0.981,0-1.614,0.642-1.614,1.742v2.531 h-0.651v-4.824h0.624v0.881c0.339-0.578,0.963-0.917,1.77-0.917c0.798,0,1.421,0.339,1.715,1.018 c0.349-0.623,1.037-1.018,1.908-1.018C190.745,265.255,191.515,265.934,191.515,267.318z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M196.926,267.125v2.99h-0.624v-0.752c-0.293,0.495-0.862,0.798-1.66,0.798 c-1.091,0-1.761-0.569-1.761-1.403c0-0.743,0.477-1.366,1.862-1.366h1.531v-0.294c0-0.825-0.468-1.274-1.366-1.274 c-0.624,0-1.211,0.22-1.605,0.568l-0.293-0.486c0.486-0.412,1.201-0.65,1.962-0.65 C196.22,265.255,196.926,265.878,196.926,267.125z M196.275,268.666v-0.789h-1.513c-0.936,0-1.238,0.367-1.238,0.862 c0,0.56,0.449,0.908,1.22,0.908C195.477,269.647,196.018,269.299,196.275,268.666z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M198.55,263.769c0-0.247,0.211-0.458,0.477-0.458c0.266,0,0.477,0.202,0.477,0.449 c0,0.266-0.202,0.477-0.477,0.477C198.761,264.236,198.55,264.025,198.55,263.769z M198.696,265.291h0.651v4.824h-0.651V265.291 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M201.163,263.31h0.651v6.805h-0.651V263.31z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 167.077,
    y: 286.75,
    style: {
      fill: "#FFFFFF"
    },
    width: 130.837,
    height: 22.403
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M179.263,296.533c0,1.367-0.99,2.192-2.623,2.192h-1.724v2.026h-0.679v-6.419h2.403 C178.273,294.333,179.263,295.158,179.263,296.533z M178.584,296.533c0-1.026-0.678-1.613-1.962-1.613h-1.706v3.209h1.706 C177.906,298.129,178.584,297.542,178.584,296.533z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M184.188,297.763v2.989h-0.624V300c-0.294,0.495-0.862,0.798-1.66,0.798 c-1.091,0-1.761-0.568-1.761-1.403c0-0.742,0.477-1.366,1.862-1.366h1.531v-0.294c0-0.825-0.468-1.274-1.366-1.274 c-0.623,0-1.21,0.221-1.605,0.568l-0.293-0.485c0.486-0.413,1.201-0.651,1.962-0.651 C183.481,295.892,184.188,296.516,184.188,297.763z M183.537,299.303v-0.788h-1.513c-0.936,0-1.238,0.366-1.238,0.861 c0,0.559,0.449,0.908,1.22,0.908C182.739,300.284,183.28,299.935,183.537,299.303z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M185.289,300.202l0.293-0.514c0.385,0.303,1.037,0.541,1.715,0.541 c0.917,0,1.293-0.313,1.293-0.789c0-1.256-3.127-0.266-3.127-2.173c0-0.789,0.679-1.376,1.908-1.376 c0.623,0,1.302,0.174,1.706,0.449l-0.284,0.523c-0.422-0.293-0.926-0.412-1.421-0.412c-0.872,0-1.256,0.339-1.256,0.798 c0,1.302,3.127,0.32,3.127,2.173c0,0.835-0.733,1.376-1.99,1.376C186.454,300.798,185.683,300.541,185.289,300.202z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M189.773,300.202l0.294-0.514c0.385,0.303,1.037,0.541,1.715,0.541 c0.917,0,1.294-0.313,1.294-0.789c0-1.256-3.127-0.266-3.127-2.173c0-0.789,0.679-1.376,1.908-1.376 c0.624,0,1.302,0.174,1.706,0.449l-0.284,0.523c-0.422-0.293-0.926-0.412-1.421-0.412c-0.872,0-1.256,0.339-1.256,0.798 c0,1.302,3.127,0.32,3.127,2.173c0,0.835-0.733,1.376-1.99,1.376C190.938,300.798,190.167,300.541,189.773,300.202z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M201.915,295.929l-1.825,4.823h-0.614l-1.523-3.952l-1.522,3.952h-0.614l-1.816-4.823h0.623 l1.513,4.099l1.55-4.099h0.56l1.54,4.099l1.532-4.099H201.915z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M202.273,298.34c0-1.431,1.045-2.448,2.458-2.448c1.413,0,2.449,1.018,2.449,2.448 c0,1.431-1.036,2.458-2.449,2.458C203.319,300.798,202.273,299.771,202.273,298.34z M206.52,298.34 c0-1.128-0.761-1.88-1.788-1.88c-1.027,0-1.797,0.752-1.797,1.88c0,1.128,0.771,1.88,1.797,1.88 C205.758,300.22,206.52,299.468,206.52,298.34z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M210.94,295.892v0.633c-0.055,0-0.11-0.009-0.156-0.009c-1.009,0-1.623,0.642-1.623,1.778v2.458 h-0.651v-4.823h0.624v0.944C209.436,296.23,210.051,295.892,210.94,295.892z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M216.47,293.947v6.805h-0.624v-0.954c-0.394,0.651-1.063,1-1.861,1c-1.376,0-2.403-1-2.403-2.458 c0-1.458,1.027-2.448,2.403-2.448c0.77,0,1.431,0.33,1.834,0.954v-2.898H216.47z M215.829,298.34c0-1.128-0.77-1.88-1.789-1.88 c-1.027,0-1.797,0.752-1.797,1.88c0,1.128,0.77,1.88,1.797,1.88C215.058,300.22,215.829,299.468,215.829,298.34z"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 167.077,
    y: 332.003,
    style: {
      opacity: 0.2
    },
    width: 130.837,
    height: 22.403
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M198.896,321.707h-2.136l-0.46,1.024h-0.422l1.753-3.835h0.4l1.753,3.835h-0.427L198.896,321.707z M198.749,321.378 l-0.92-2.06l-0.92,2.06H198.749z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M200.34,318.667h0.389v4.064h-0.389V318.667z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M203.266,319.828v0.378c-0.033,0-0.066-0.006-0.093-0.006c-0.603,0-0.97,0.384-0.97,1.064v1.468h-0.389v-2.882h0.372 v0.564C202.368,320.031,202.734,319.828,203.266,319.828z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M206.45,321.411h-2.41c0.044,0.603,0.504,1.003,1.134,1.003c0.351,0,0.663-0.126,0.882-0.378l0.219,0.252 c-0.257,0.307-0.657,0.471-1.112,0.471c-0.898,0-1.512-0.613-1.512-1.468c0-0.854,0.597-1.463,1.408-1.463 c0.811,0,1.397,0.597,1.397,1.463C206.456,321.323,206.45,321.367,206.45,321.411z M204.04,321.121h2.043 c-0.049-0.564-0.46-0.959-1.024-0.959C204.5,320.162,204.089,320.557,204.04,321.121z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M209.345,320.945v1.786h-0.372v-0.449c-0.175,0.296-0.515,0.477-0.992,0.477c-0.652,0-1.052-0.34-1.052-0.838 c0-0.444,0.285-0.816,1.112-0.816h0.915v-0.175c0-0.493-0.279-0.762-0.816-0.762c-0.373,0-0.723,0.131-0.959,0.34l-0.175-0.291 c0.29-0.246,0.718-0.389,1.172-0.389C208.923,319.828,209.345,320.2,209.345,320.945z M208.956,321.866v-0.472h-0.904 c-0.559,0-0.74,0.22-0.74,0.516c0,0.334,0.269,0.542,0.729,0.542C208.479,322.452,208.802,322.244,208.956,321.866z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M213.044,318.667v4.064h-0.372v-0.569c-0.236,0.389-0.636,0.597-1.112,0.597c-0.821,0-1.435-0.597-1.435-1.468 c0-0.871,0.614-1.463,1.435-1.463c0.46,0,0.854,0.197,1.096,0.569v-1.73H213.044z M212.661,321.291 c0-0.674-0.46-1.123-1.068-1.123c-0.614,0-1.074,0.449-1.074,1.123c0,0.674,0.46,1.123,1.074,1.123 C212.201,322.414,212.661,321.965,212.661,321.291z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M216.553,319.85l-1.44,3.227c-0.241,0.564-0.548,0.745-0.959,0.745c-0.268,0-0.526-0.087-0.701-0.263l0.181-0.29 c0.142,0.143,0.317,0.219,0.526,0.219c0.257,0,0.433-0.12,0.597-0.482l0.126-0.279l-1.288-2.876H214l1.085,2.449l1.084-2.449 H216.553z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M220.714,320.945v1.786h-0.373v-0.449c-0.175,0.296-0.515,0.477-0.992,0.477c-0.652,0-1.052-0.34-1.052-0.838 c0-0.444,0.285-0.816,1.112-0.816h0.915v-0.175c0-0.493-0.279-0.762-0.816-0.762c-0.373,0-0.723,0.131-0.958,0.34l-0.175-0.291 c0.29-0.246,0.718-0.389,1.172-0.389C220.292,319.828,220.714,320.2,220.714,320.945z M220.325,321.866v-0.472h-0.904 c-0.559,0-0.74,0.22-0.74,0.516c0,0.334,0.269,0.542,0.729,0.542C219.848,322.452,220.171,322.244,220.325,321.866z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M227.964,321.06v1.671h-0.389v-1.633c0-0.607-0.307-0.92-0.827-0.92c-0.592,0-0.964,0.384-0.964,1.041v1.512h-0.389 v-1.633c0-0.607-0.307-0.92-0.833-0.92c-0.586,0-0.964,0.384-0.964,1.041v1.512h-0.389v-2.882h0.372v0.526 c0.203-0.345,0.575-0.548,1.057-0.548c0.477,0,0.849,0.203,1.024,0.608c0.208-0.373,0.619-0.608,1.139-0.608 C227.504,319.828,227.964,320.233,227.964,321.06z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M231.545,321.411h-2.41c0.043,0.603,0.504,1.003,1.134,1.003c0.35,0,0.663-0.126,0.882-0.378l0.219,0.252 c-0.257,0.307-0.657,0.471-1.112,0.471c-0.898,0-1.512-0.613-1.512-1.468c0-0.854,0.597-1.463,1.408-1.463 c0.811,0,1.397,0.597,1.397,1.463C231.55,321.323,231.545,321.367,231.545,321.411z M229.135,321.121h2.043 c-0.049-0.564-0.46-0.959-1.024-0.959C229.595,320.162,229.184,320.557,229.135,321.121z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M237.102,321.06v1.671h-0.389v-1.633c0-0.607-0.307-0.92-0.827-0.92c-0.592,0-0.964,0.384-0.964,1.041v1.512h-0.389 v-1.633c0-0.607-0.307-0.92-0.833-0.92c-0.586,0-0.964,0.384-0.964,1.041v1.512h-0.389v-2.882h0.372v0.526 c0.203-0.345,0.575-0.548,1.057-0.548c0.477,0,0.849,0.203,1.024,0.608c0.208-0.373,0.619-0.608,1.139-0.608 C236.642,319.828,237.102,320.233,237.102,321.06z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M241.083,321.291c0,0.871-0.613,1.468-1.435,1.468c-0.477,0-0.877-0.208-1.112-0.597v0.569h-0.372v-4.064h0.389v1.73 c0.241-0.372,0.636-0.569,1.096-0.569C240.469,319.828,241.083,320.42,241.083,321.291z M240.694,321.291 c0-0.674-0.466-1.123-1.074-1.123c-0.614,0-1.074,0.449-1.074,1.123c0,0.674,0.46,1.123,1.074,1.123 C240.228,322.414,240.694,321.965,240.694,321.291z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M244.389,321.411h-2.41c0.044,0.603,0.504,1.003,1.134,1.003c0.351,0,0.663-0.126,0.882-0.378l0.219,0.252 c-0.257,0.307-0.657,0.471-1.112,0.471c-0.898,0-1.512-0.613-1.512-1.468c0-0.854,0.597-1.463,1.408-1.463 c0.811,0,1.397,0.597,1.397,1.463C244.394,321.323,244.389,321.367,244.389,321.411z M241.979,321.121h2.043 c-0.049-0.564-0.46-0.959-1.024-0.959C242.439,320.162,242.028,320.557,241.979,321.121z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M246.642,319.828v0.378c-0.033,0-0.066-0.006-0.093-0.006c-0.602,0-0.97,0.384-0.97,1.064v1.468h-0.389v-2.882h0.373 v0.564C245.744,320.031,246.11,319.828,246.642,319.828z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M249.163,319.878c0-0.395-0.323-0.669-0.882-0.669c-0.465,0-0.805,0.153-1.046,0.444l-0.29-0.22 c0.296-0.361,0.751-0.569,1.364-0.569c0.767,0,1.26,0.367,1.26,0.953c0,0.936-1.002,0.98-1.002,1.764h-0.406 C248.161,320.677,249.163,320.595,249.163,319.878z M248.079,322.474c0-0.158,0.126-0.279,0.285-0.279 c0.165,0,0.29,0.121,0.29,0.279c0,0.153-0.126,0.285-0.29,0.285C248.205,322.759,248.079,322.627,248.079,322.474z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M251.872,318.897h0.888v3.112h1.922v0.723h-2.81V318.897z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M254.882,321.258c0-0.888,0.685-1.518,1.622-1.518c0.937,0,1.616,0.63,1.616,1.518c0,0.888-0.679,1.518-1.616,1.518 C255.566,322.775,254.882,322.146,254.882,321.258z M257.254,321.258c0-0.51-0.323-0.816-0.751-0.816 c-0.427,0-0.756,0.307-0.756,0.816c0,0.51,0.329,0.816,0.756,0.816C256.931,322.074,257.254,321.768,257.254,321.258z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M261.732,319.784v2.454c0,1.096-0.591,1.6-1.654,1.6c-0.559,0-1.101-0.137-1.446-0.405l0.34-0.613 c0.252,0.202,0.663,0.334,1.04,0.334c0.603,0,0.866-0.274,0.866-0.806v-0.126c-0.225,0.247-0.548,0.367-0.931,0.367 c-0.816,0-1.474-0.564-1.474-1.424c0-0.86,0.657-1.425,1.474-1.425c0.411,0,0.751,0.138,0.975,0.422v-0.378H261.732z  M260.888,321.165c0-0.433-0.323-0.724-0.772-0.724c-0.449,0-0.778,0.291-0.778,0.724c0,0.433,0.329,0.723,0.778,0.723 C260.565,321.888,260.888,321.598,260.888,321.165z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M263.976,318.897c0-0.268,0.213-0.477,0.531-0.477c0.318,0,0.531,0.197,0.531,0.461c0,0.284-0.213,0.492-0.531,0.492 C264.19,319.373,263.976,319.165,263.976,318.897z M264.08,319.784h0.854v2.947h-0.854V319.784z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M268.743,321.044v1.688h-0.854v-1.556c0-0.477-0.219-0.695-0.597-0.695c-0.411,0-0.706,0.252-0.706,0.794v1.457h-0.854 v-2.947h0.816v0.346c0.23-0.252,0.575-0.39,0.975-0.39C268.217,319.74,268.743,320.146,268.743,321.044z"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 167.077,
    y: 330.632,
    style: {
      fill: "#ef233c"
    },
    width: 130.837,
    height: 22.403
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M215.602,345.314l-1.654-2.355c-0.154,0.011-0.318,0.021-0.482,0.021h-1.895v2.334h-1.096v-7.669 h2.991c1.994,0,3.199,1.008,3.199,2.673c0,1.184-0.613,2.038-1.687,2.422l1.818,2.574H215.602z M215.569,340.317 c0-1.096-0.734-1.72-2.136-1.72h-1.862v3.451h1.862C214.835,342.049,215.569,341.413,215.569,340.317z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M223.518,342.761h-4.711c0.132,1.019,0.953,1.698,2.104,1.698c0.679,0,1.249-0.231,1.676-0.701 l0.581,0.679c-0.526,0.614-1.326,0.942-2.29,0.942c-1.874,0-3.123-1.237-3.123-2.969c0-1.72,1.238-2.958,2.915-2.958 c1.676,0,2.87,1.205,2.87,2.991C223.539,342.53,223.528,342.662,223.518,342.761z M218.806,342.005h3.725 c-0.109-0.976-0.844-1.665-1.862-1.665C219.661,340.34,218.916,341.019,218.806,342.005z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M230.556,339.507v5.018c0,2.049-1.041,2.98-3.013,2.98c-1.063,0-2.136-0.296-2.771-0.866 l0.504-0.811c0.537,0.46,1.38,0.756,2.235,0.756c1.37,0,1.994-0.635,1.994-1.95v-0.46c-0.504,0.603-1.26,0.898-2.093,0.898 c-1.676,0-2.947-1.14-2.947-2.815c0-1.676,1.271-2.805,2.947-2.805c0.866,0,1.654,0.317,2.147,0.953v-0.898H230.556z  M229.525,342.257c0-1.129-0.833-1.885-1.994-1.885c-1.172,0-2.005,0.756-2.005,1.885c0,1.117,0.833,1.896,2.005,1.896 C228.693,344.152,229.525,343.374,229.525,342.257z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M232.379,337.71c0-0.383,0.307-0.69,0.712-0.69c0.405,0,0.712,0.296,0.712,0.669 c0,0.395-0.296,0.701-0.712,0.701C232.686,338.39,232.379,338.094,232.379,337.71z M232.565,339.507h1.052v5.807h-1.052V339.507z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M234.891,344.7l0.438-0.833c0.493,0.351,1.282,0.603,2.038,0.603c0.975,0,1.381-0.296,1.381-0.789 c0-1.304-3.67-0.175-3.67-2.486c0-1.041,0.931-1.742,2.421-1.742c0.756,0,1.61,0.197,2.114,0.525l-0.449,0.833 c-0.526-0.34-1.107-0.46-1.676-0.46c-0.92,0-1.37,0.34-1.37,0.8c0,1.369,3.682,0.252,3.682,2.509c0,1.052-0.964,1.72-2.509,1.72 C236.326,345.379,235.373,345.083,234.891,344.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M244.381,344.974c-0.318,0.274-0.8,0.405-1.271,0.405c-1.172,0-1.84-0.647-1.84-1.818v-3.188 h-0.986v-0.865h0.986v-1.271h1.052v1.271h1.665v0.865h-1.665v3.145c0,0.625,0.329,0.976,0.909,0.976 c0.307,0,0.602-0.099,0.822-0.274L244.381,344.974z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M250.685,342.761h-4.712c0.132,1.019,0.953,1.698,2.104,1.698c0.679,0,1.249-0.231,1.676-0.701 l0.581,0.679c-0.526,0.614-1.326,0.942-2.29,0.942c-1.874,0-3.122-1.237-3.122-2.969c0-1.72,1.238-2.958,2.915-2.958 c1.676,0,2.87,1.205,2.87,2.991C250.706,342.53,250.695,342.662,250.685,342.761z M245.973,342.005h3.725 c-0.109-0.976-0.844-1.665-1.862-1.665C246.828,340.34,246.083,341.019,245.973,342.005z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M255.29,339.452v1.019c-0.087-0.011-0.164-0.011-0.241-0.011c-1.128,0-1.83,0.69-1.83,1.961v2.893 h-1.052v-5.807h1.008v0.976C253.548,339.803,254.271,339.452,255.29,339.452z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M209.593,177.608l0.444-0.936c0.624,0.564,1.691,0.972,2.771,0.972 c1.451,0,2.075-0.564,2.075-1.295c0-2.051-5.085-0.755-5.085-3.874c0-1.295,1.007-2.398,3.214-2.398 c0.983,0,2.003,0.264,2.699,0.744l-0.396,0.96c-0.731-0.468-1.559-0.684-2.303-0.684c-1.427,0-2.038,0.6-2.038,1.331 c0,2.051,5.085,0.768,5.085,3.85c0,1.283-1.031,2.387-3.25,2.387C211.524,178.664,210.265,178.232,209.593,177.608z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M217.441,170.245c0-0.42,0.335-0.756,0.779-0.756c0.444,0,0.78,0.324,0.78,0.732 c0,0.432-0.324,0.768-0.78,0.768C217.776,170.988,217.441,170.664,217.441,170.245z M217.645,172.211h1.151v6.357h-1.151V172.211 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M227.073,172.211v5.493c0,2.243-1.139,3.263-3.298,3.263c-1.164,0-2.339-0.324-3.035-0.948 l0.552-0.888c0.588,0.504,1.511,0.828,2.447,0.828c1.499,0,2.183-0.695,2.183-2.135v-0.504c-0.551,0.66-1.379,0.984-2.291,0.984 c-1.835,0-3.226-1.248-3.226-3.083c0-1.835,1.391-3.07,3.226-3.07c0.947,0,1.811,0.348,2.351,1.043v-0.983H227.073z  M225.946,175.222c0-1.235-0.911-2.063-2.183-2.063c-1.283,0-2.195,0.828-2.195,2.063c0,1.223,0.912,2.075,2.195,2.075 C225.035,177.296,225.946,176.445,225.946,175.222z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M235.305,174.91v3.658h-1.151v-3.526c0-1.248-0.623-1.859-1.715-1.859 c-1.224,0-2.015,0.732-2.015,2.111v3.274h-1.151v-6.357h1.104v0.96c0.468-0.647,1.283-1.02,2.29-1.02 C234.214,172.151,235.305,173.039,235.305,174.91z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M246.597,172.211v6.357h-1.091v-0.96c-0.468,0.66-1.259,1.031-2.159,1.031 c-1.643,0-2.735-0.899-2.735-2.771v-3.658h1.151v3.526c0,1.248,0.624,1.871,1.715,1.871c1.199,0,1.967-0.744,1.967-2.111v-3.286 H246.597z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M255.381,175.39c0,1.955-1.355,3.25-3.214,3.25c-0.899,0-1.691-0.348-2.219-1.031v3.286h-1.151 v-8.683h1.104v1.007c0.516-0.708,1.331-1.067,2.267-1.067C254.025,172.151,255.381,173.447,255.381,175.39z M254.217,175.39 c0-1.343-0.923-2.231-2.146-2.231c-1.211,0-2.135,0.888-2.135,2.231c0,1.355,0.923,2.243,2.135,2.243 C253.294,177.632,254.217,176.745,254.217,175.39z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 167.077,
    y: 225.544,
    style: {
      fill: "#FFFFFF"
    },
    width: 130.837,
    height: 22.403
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M174.237,233.093h0.679v5.832h3.595v0.587h-4.273V233.093z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M183.16,236.523v2.989h-0.624v-0.752c-0.293,0.495-0.862,0.798-1.66,0.798 c-1.091,0-1.761-0.568-1.761-1.403c0-0.742,0.477-1.366,1.862-1.366h1.531v-0.293c0-0.825-0.468-1.275-1.366-1.275 c-0.624,0-1.211,0.221-1.605,0.569l-0.294-0.486c0.486-0.413,1.201-0.651,1.962-0.651 C182.454,234.651,183.16,235.275,183.16,236.523z M182.509,238.064v-0.789h-1.513c-0.936,0-1.238,0.367-1.238,0.862 c0,0.559,0.449,0.907,1.22,0.907C181.711,239.044,182.252,238.695,182.509,238.064z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M184.261,238.962l0.294-0.514c0.385,0.303,1.037,0.541,1.715,0.541 c0.917,0,1.294-0.312,1.294-0.789c0-1.256-3.127-0.266-3.127-2.173c0-0.789,0.679-1.376,1.908-1.376 c0.623,0,1.302,0.175,1.705,0.449l-0.284,0.523c-0.422-0.294-0.926-0.413-1.421-0.413c-0.872,0-1.256,0.339-1.256,0.798 c0,1.302,3.127,0.321,3.127,2.174c0,0.834-0.733,1.375-1.99,1.375C185.426,239.558,184.655,239.301,184.261,238.962z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M191.956,239.219c-0.257,0.229-0.642,0.339-1.018,0.339c-0.908,0-1.412-0.514-1.412-1.403v-2.916 h-0.862v-0.55h0.862v-1.055h0.651v1.055h1.467v0.55h-1.467v2.88c0,0.568,0.293,0.88,0.834,0.88c0.266,0,0.532-0.082,0.715-0.247 L191.956,239.219z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M201.044,233.093v6.419h-0.56l-4.126-5.209v5.209h-0.679v-6.419h0.56l4.136,5.209v-5.209H201.044 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M206.638,236.523v2.989h-0.623v-0.752c-0.294,0.495-0.862,0.798-1.66,0.798 c-1.091,0-1.761-0.568-1.761-1.403c0-0.742,0.477-1.366,1.862-1.366h1.531v-0.293c0-0.825-0.468-1.275-1.366-1.275 c-0.624,0-1.21,0.221-1.605,0.569l-0.293-0.486c0.486-0.413,1.201-0.651,1.962-0.651 C205.932,234.651,206.638,235.275,206.638,236.523z M205.987,238.064v-0.789h-1.513c-0.936,0-1.238,0.367-1.238,0.862 c0,0.559,0.449,0.907,1.22,0.907C205.189,239.044,205.73,238.695,205.987,238.064z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M216.368,236.715v2.797h-0.651v-2.732c0-1.019-0.514-1.541-1.385-1.541 c-0.99,0-1.614,0.643-1.614,1.742v2.531h-0.651v-2.732c0-1.019-0.514-1.541-1.394-1.541c-0.981,0-1.614,0.643-1.614,1.742v2.531 h-0.651v-4.823h0.623v0.88c0.339-0.577,0.963-0.917,1.77-0.917c0.798,0,1.421,0.34,1.715,1.019 c0.349-0.624,1.037-1.019,1.908-1.019C215.598,234.651,216.368,235.33,216.368,236.715z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M222.357,237.302h-4.035c0.074,1.009,0.844,1.679,1.898,1.679c0.587,0,1.11-0.211,1.477-0.633 l0.367,0.422c-0.431,0.513-1.101,0.788-1.861,0.788c-1.504,0-2.531-1.027-2.531-2.457c0-1.431,0.999-2.449,2.357-2.449 c1.357,0,2.338,1,2.338,2.449C222.367,237.155,222.357,237.229,222.357,237.302z M218.322,236.815h3.421 c-0.083-0.944-0.77-1.604-1.715-1.604C219.093,235.211,218.405,235.871,218.322,236.815z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 167.077,
    y: 194.941,
    style: {
      fill: "#FFFFFF"
    },
    width: 130.837,
    height: 22.403
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M174.915,203.076v2.522h3.32v0.587h-3.32v2.724h-0.679v-6.419h4.402v0.587H174.915z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M179.667,202.563c0-0.248,0.211-0.458,0.477-0.458c0.266,0,0.477,0.202,0.477,0.45 c0,0.266-0.202,0.477-0.477,0.477C179.877,203.03,179.667,202.819,179.667,202.563z M179.813,204.085h0.651v4.824h-0.651 V204.085z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M184.71,204.048v0.633c-0.055,0-0.11-0.009-0.156-0.009c-1.009,0-1.623,0.642-1.623,1.779v2.458 h-0.651v-4.824h0.624v0.945C183.206,204.388,183.821,204.048,184.71,204.048z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M185.251,208.358l0.293-0.514c0.385,0.303,1.037,0.541,1.715,0.541 c0.917,0,1.293-0.311,1.293-0.788c0-1.256-3.127-0.266-3.127-2.173c0-0.788,0.679-1.376,1.908-1.376 c0.624,0,1.302,0.174,1.706,0.449l-0.284,0.523c-0.422-0.293-0.926-0.413-1.421-0.413c-0.872,0-1.256,0.339-1.256,0.798 c0,1.302,3.127,0.321,3.127,2.173c0,0.835-0.733,1.376-1.99,1.376C186.417,208.955,185.646,208.698,185.251,208.358z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M192.946,208.615c-0.257,0.229-0.642,0.339-1.018,0.339c-0.908,0-1.412-0.514-1.412-1.403v-2.916 h-0.862v-0.55h0.862v-1.055h0.651v1.055h1.467v0.55h-1.467v2.879c0,0.569,0.294,0.88,0.835,0.88 c0.266,0,0.532-0.083,0.715-0.247L192.946,208.615z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M202.034,202.489v6.419h-0.56l-4.126-5.209v5.209h-0.679v-6.419h0.56l4.136,5.209v-5.209H202.034 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M207.629,205.919v2.99h-0.624v-0.752c-0.294,0.495-0.862,0.798-1.66,0.798 c-1.091,0-1.761-0.569-1.761-1.403c0-0.743,0.477-1.366,1.862-1.366h1.531v-0.294c0-0.825-0.468-1.275-1.366-1.275 c-0.624,0-1.211,0.22-1.605,0.569l-0.293-0.486c0.486-0.413,1.201-0.651,1.962-0.651 C206.922,204.048,207.629,204.672,207.629,205.919z M206.977,207.46v-0.789h-1.513c-0.936,0-1.238,0.367-1.238,0.862 c0,0.559,0.449,0.908,1.22,0.908C206.18,208.441,206.721,208.092,206.977,207.46z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M217.358,206.112v2.797h-0.651v-2.733c0-1.018-0.514-1.54-1.385-1.54 c-0.99,0-1.614,0.642-1.614,1.742v2.531h-0.651v-2.733c0-1.018-0.514-1.54-1.394-1.54c-0.981,0-1.614,0.642-1.614,1.742v2.531 h-0.651v-4.824h0.624v0.88c0.339-0.578,0.963-0.917,1.77-0.917c0.798,0,1.421,0.339,1.715,1.018 c0.349-0.624,1.037-1.018,1.908-1.018C216.588,204.048,217.358,204.727,217.358,206.112z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M223.348,206.699h-4.035c0.074,1.009,0.844,1.678,1.898,1.678c0.587,0,1.11-0.211,1.477-0.633 l0.367,0.422c-0.431,0.513-1.101,0.789-1.861,0.789c-1.504,0-2.531-1.027-2.531-2.458c0-1.431,0.999-2.449,2.357-2.449 c1.357,0,2.338,1,2.338,2.449C223.357,206.552,223.348,206.625,223.348,206.699z M219.313,206.212h3.421 c-0.083-0.944-0.77-1.605-1.715-1.605C220.083,204.608,219.395,205.268,219.313,206.212z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Plant"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#ef233c",
      strokeWidth: 0.9446,
      strokeMiterlimit: 10
    },
    d: "M136.442,345.55c0,0-6.62-5.519-12.296,0 c-5.676,5.519-6.772,39.711-6.772,39.711"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#ef233c",
      strokeWidth: 0.9446,
      strokeMiterlimit: 10
    },
    d: "M116.904,391.863 c0,0,3.902-40.126-10.79-56.989"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#ef233c",
      strokeWidth: 0.9446,
      strokeMiterlimit: 10
    },
    d: "M118.302,387.634 c0,0-3.005-45.68,8.014-55.815"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#ef233c",
      strokeWidth: 0.9446,
      strokeMiterlimit: 10
    },
    d: "M116.904,387.634 c0,0-0.256-30.185-8.445-34.878c-8.189-4.692-12.363,10.612-12.363,10.612"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#ef233c",
      strokeWidth: 0.9446,
      strokeMiterlimit: 10
    },
    d: "M120.139,387.634 c0,0-1.336-23.173,5.009-31.455c6.344-8.282,13.023,3.548,13.023,3.548"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#ef233c",
      strokeWidth: 0.9446,
      strokeMiterlimit: 10
    },
    d: "M117.928,390.738 c0,0,4.103-54.194-2.687-63.377"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ef233c"
    },
    d: "M101.447,357.154c0,0,4.083,1.505,2.869,5.059c-1.214,3.554-14.125,9.402-14.125,9.402 s-5.407-4.956-0.441-13.017C94.716,350.538,101.337,354.611,101.447,357.154z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    d: "M101.447,357.154c0,0,4.083,1.505,2.869,5.059 c-1.214,3.554-14.125,9.402-14.125,9.402s-5.407-4.956-0.441-13.017C94.716,350.538,101.337,354.611,101.447,357.154z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ef233c"
    },
    d: "M119.197,350.389c0,0-4.348-0.182-4.595,3.565c-0.247,3.747,9.419,14.114,9.419,14.114 s6.898-2.494,5.416-11.845C127.956,346.873,120.278,348.084,119.197,350.389z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    d: "M119.197,350.389c0,0-4.348-0.182-4.595,3.565 c-0.247,3.747,9.419,14.114,9.419,14.114s6.898-2.494,5.416-11.845C127.956,346.873,120.278,348.084,119.197,350.389z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ef233c"
    },
    d: "M122.878,332.452c0,0-2.899-0.311-2.665-2.077c0.233-1.766,11.269-6.31,17.779,1.038 c0,0-4.169,7.161-10.195,7.255C121.771,338.762,122.878,332.452,122.878,332.452z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    d: "M122.878,332.452c0,0-2.899-0.311-2.665-2.077 c0.233-1.766,11.269-6.31,17.779,1.038c0,0-4.169,7.161-10.195,7.255C121.771,338.762,122.878,332.452,122.878,332.452z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ef233c"
    },
    d: "M117.477,328.164c0,0,2.625,1.269,3.36-0.353c0.736-1.622-6.226-11.315-15.638-8.522 c0,0-0.249,8.283,4.816,11.549C115.079,334.105,117.477,328.164,117.477,328.164z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    d: "M117.477,328.164c0,0,2.625,1.269,3.36-0.353 c0.736-1.622-6.226-11.315-15.638-8.522c0,0-0.249,8.283,4.816,11.549C115.079,334.105,117.477,328.164,117.477,328.164z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ef233c"
    },
    d: "M131.201,355.725c0,0-2.001-1.615,0.158-2.404c2.159-0.788,12.753-0.564,12.863,9.93 c0,0-12.338,2.05-13.866-1.947C128.83,357.307,131.201,355.725,131.201,355.725z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    d: "M131.201,355.725c0,0-2.001-1.615,0.158-2.404 c2.159-0.788,12.753-0.564,12.863,9.93c0,0-12.338,2.05-13.866-1.947C128.83,357.307,131.201,355.725,131.201,355.725z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ef233c"
    },
    d: "M106.041,332.189c0,0,2.001-1.615-0.158-2.404c-2.159-0.789-12.753-0.565-12.863,9.929 c0,0,12.338,2.051,13.866-1.947C108.412,333.771,106.041,332.189,106.041,332.189z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    d: "M106.041,332.189c0,0,2.001-1.615-0.158-2.404 c-2.159-0.789-12.753-0.565-12.863,9.929c0,0,12.338,2.051,13.866-1.947C108.412,333.771,106.041,332.189,106.041,332.189z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ef233c"
    },
    d: "M112.564,340.642c0,0,0.176-1.964-1.409-1.194c-1.585,0.77-7.108,6.728-1.383,12.382 c0,0,7.706-5.707,6.317-8.679C114.699,340.178,112.564,340.642,112.564,340.642z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    d: "M112.564,340.642c0,0,0.176-1.964-1.409-1.194 c-1.585,0.77-7.108,6.728-1.383,12.382c0,0,7.706-5.707,6.317-8.679C114.699,340.178,112.564,340.642,112.564,340.642z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ef233c"
    },
    d: "M132.99,343.441c0,0-1.196-1.567,0.556-1.761c1.751-0.194,9.601,1.901,7.773,9.736 c0,0-9.563-0.719-9.972-3.974C130.936,344.187,132.99,343.441,132.99,343.441z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    d: "M132.99,343.441c0,0-1.196-1.567,0.556-1.761 c1.751-0.194,9.601,1.901,7.773,9.736c0,0-9.563-0.719-9.972-3.974C130.936,344.187,132.99,343.441,132.99,343.441z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#263238"
    },
    points: "102.16,416.723 133.075,416.723 137.184,386.661 98.051,386.661  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    points: "102.16,416.723 133.075,416.723 137.184,386.661  98.051,386.661  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M141.059,384.224v2.856c0,1.911-1.549,3.461-3.461,3.461H97.25c-1.911,0-3.461-1.549-3.461-3.461 v-2.856H141.059z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Speech_bubble"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ef233c"
    },
    d: "M398.621,99.306h-28.728c-4.886,0-8.846,3.961-8.846,8.846v25.002 c0,4.885,3.961,8.846,8.846,8.846h8.388l-2.028,7.894L384.23,142h14.391c4.885,0,8.846-3.96,8.846-8.846v-25.002 C407.467,103.267,403.507,99.306,398.621,99.306z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.7,
      fill: "#FFFFFF"
    },
    d: "M398.621,99.306h-28.728c-4.886,0-8.846,3.961-8.846,8.846v25.002 c0,4.885,3.961,8.846,8.846,8.846h8.388l-2.028,7.894L384.23,142h14.391c4.885,0,8.846-3.96,8.846-8.846v-25.002 C407.467,103.267,403.507,99.306,398.621,99.306z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 27.3078 307.0175)",
    style: {
      fill: "#ef233c"
    },
    cx: 384.257,
    cy: 120.545,
    rx: 14.258,
    ry: 14.258
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M382.76,126.914c-0.385,0-0.75-0.169-0.999-0.462l-5.594-6.591 c-0.468-0.552-0.4-1.378,0.151-1.847c0.551-0.467,1.378-0.401,1.847,0.151l4.595,5.414l7.588-8.94 c0.469-0.553,1.296-0.619,1.847-0.151c0.552,0.468,0.62,1.295,0.151,1.847l-8.587,10.118 C383.51,126.745,383.145,126.914,382.76,126.914z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Character"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ef233c"
    },
    d: "M393.644,253.557c0,0-17.415-2.192-43.791,5.039c0,0-4.246-47.138-3.74-53.613 s40.723-4.579,40.723-4.579s1.038,18.866,3.626,30.249C393.05,242.035,394.97,251.368,393.644,253.557z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M393.644,253.557c0,0-17.415-2.192-43.791,5.039c0,0-4.246-47.138-3.74-53.613 s40.723-4.579,40.723-4.579s1.038,18.866,3.626,30.249C393.05,242.035,394.97,251.368,393.644,253.557z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(255, 195, 189)"
    },
    points: "337.128,409.621 344.228,411.631 345.918,400.581 346.828,394.671 339.728,392.661  338.518,400.581  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(255, 195, 189)"
    },
    points: "377.948,410.201 385.268,411.171 385.338,400.581 385.388,394.001 378.058,393.041  378.008,400.581  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2
    },
    points: "378.058,393.041 378.008,400.581 385.338,400.581 385.388,394.001  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2
    },
    points: "338.518,400.581 345.918,400.581 346.828,394.671 339.728,392.661  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "rgb(255, 195, 189)"
    },
    d: "M305.608,208.81l-7.048-2.083l1.287,8.049c0,0,6.4,1.479,7.023-1.851L305.608,208.81z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(255, 195, 189)"
    },
    points: "291.525,208.596 294.981,215.141 299.847,214.775 298.56,206.727  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(255, 195, 189)"
    },
    points: "315.34,210.867 303.765,208.276 302.713,213.898 313.222,216.461  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ef233c"
    },
    d: "M350.373,205.794c0,0-0.25,0.3-0.68,0.81c-1.46,1.71-5.03,5.84-8.69,9.4 c-3,2.9-6.04,5.43-8.02,5.94c-5.67,1.46-26.28-4.61-26.28-4.61l2.13-8.36c0,0,19.2,2.55,20.69,2.55 c1.13,0,12.81-16.92,15.64-18.31L350.373,205.794z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M349.693,206.604c-1.46,1.71-5.03,5.84-8.69,9.4c0.74-5.86,2.89-11.24,5.72-14.64 c0.3-0.36,0.6-0.66,0.9-0.88L349.693,206.604z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M337.215,408.513l8.063-0.217c0.302-0.008,0.571,0.194,0.647,0.485l1.694,6.493 c0.176,0.673-0.318,1.329-1.015,1.336c-2.91,0.029-7.119-0.027-10.775,0.071c-4.275,0.115-6.992-0.095-12.005,0.04 c-3.031,0.082-3.982-2.946-2.723-3.256c5.731-1.413,9.477-1.134,14.358-4.332C335.988,408.786,336.578,408.53,337.215,408.513z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ef233c"
    },
    d: "M336.525,409.548c-0.007,0.003-0.015,0.005-0.023,0.007c-1.18,0.268-3.286,0.615-4.122-0.077 c-0.252-0.209-0.372-0.49-0.358-0.838c0.009-0.207,0.103-0.37,0.272-0.471c0.882-0.53,3.901,0.897,4.242,1.06 c0.067,0.032,0.107,0.103,0.099,0.176C336.629,409.47,336.585,409.525,336.525,409.548z M332.538,408.439 c-0.023,0.009-0.044,0.018-0.063,0.029c-0.069,0.041-0.1,0.097-0.104,0.189c-0.009,0.236,0.066,0.417,0.231,0.554 c0.469,0.388,1.686,0.426,3.307,0.112C334.719,408.799,333.088,408.232,332.538,408.439z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ef233c"
    },
    d: "M336.525,409.548c-0.041,0.016-0.087,0.016-0.129-0.002c-0.905-0.374-2.728-1.916-2.623-2.75 c0.025-0.196,0.155-0.441,0.634-0.504c0.356-0.046,0.685,0.046,0.981,0.272c0.967,0.742,1.237,2.716,1.248,2.8 c0.008,0.062-0.017,0.122-0.067,0.16C336.555,409.534,336.54,409.542,336.525,409.548z M334.277,406.678 c-0.143,0.054-0.153,0.133-0.157,0.164c-0.063,0.501,1.182,1.717,2.111,2.237c-0.116-0.576-0.421-1.753-1.056-2.24 c-0.221-0.17-0.457-0.236-0.721-0.202C334.38,406.647,334.322,406.661,334.277,406.678z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M378.241,408.513l8.063-0.217c0.302-0.008,0.571,0.194,0.647,0.485l1.694,6.493 c0.176,0.673-0.318,1.329-1.015,1.336c-2.91,0.029-7.119-0.027-10.775,0.071c-4.275,0.115-6.992-0.095-12.005,0.04 c-3.031,0.082-3.982-2.946-2.723-3.256c5.731-1.413,9.477-1.134,14.358-4.332C377.013,408.786,377.604,408.53,378.241,408.513z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ef233c"
    },
    d: "M377.551,409.548c-0.007,0.003-0.015,0.005-0.023,0.007c-1.181,0.268-3.286,0.615-4.122-0.077 c-0.252-0.209-0.372-0.49-0.358-0.838c0.009-0.207,0.103-0.37,0.272-0.471c0.882-0.53,3.901,0.897,4.242,1.06 c0.067,0.032,0.107,0.103,0.099,0.176C377.655,409.47,377.611,409.525,377.551,409.548z M373.564,408.439 c-0.023,0.009-0.044,0.018-0.063,0.029c-0.069,0.041-0.1,0.097-0.103,0.189c-0.009,0.236,0.066,0.417,0.231,0.554 c0.469,0.388,1.686,0.426,3.307,0.112C375.745,408.799,374.114,408.232,373.564,408.439z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ef233c"
    },
    d: "M377.551,409.548c-0.041,0.016-0.087,0.016-0.129-0.002c-0.905-0.374-2.728-1.916-2.623-2.75 c0.025-0.196,0.155-0.441,0.634-0.504c0.356-0.046,0.686,0.046,0.981,0.272c0.967,0.742,1.237,2.716,1.248,2.8 c0.008,0.062-0.017,0.122-0.067,0.16C377.581,409.534,377.566,409.542,377.551,409.548z M375.303,406.678 c-0.143,0.054-0.153,0.133-0.157,0.164c-0.063,0.501,1.182,1.717,2.111,2.237c-0.116-0.576-0.421-1.753-1.056-2.24 c-0.221-0.17-0.457-0.236-0.72-0.202C375.405,406.647,375.348,406.661,375.303,406.678z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M393.049,249.257c3.878,16.816-2.777,149.065-2.777,149.065h-12.862l-5.499-110.215 l-20.255,110.215l-13.746-1.001c8.986-85.377,16.93-136.35,16.93-136.35l-0.019-6.441L393.049,249.257z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      fill: "#FFFFFF"
    },
    d: "M337.908,397.321l13.75,1l15.94-86.76l4.31-23.45l5.5,110.21h12.86 c0,0,6.66-132.25,2.78-149.06l-38.23,5.27l0.02,6.44C354.838,260.971,346.898,311.941,337.908,397.321z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M386.121,186.99c-0.465,8.236-0.112,16.451,0.612,24.101c0.533,5.596,1.278,10.887,2.068,15.661 c1.849,11.191,3.949,19.578,4.248,22.505c-5.602,0.775-26.715,3.689-38.228,5.273c-13.94-38.978-8.69-61.665-8.69-61.665 s3.986-1.703,8.768-3c0.629-0.175,1.273-0.333,1.929-0.484c4.245-0.984,11.337-1.802,16.253-2.243 c1.034-0.092,2.085-0.158,3.111-0.206C381.414,186.694,386.121,186.99,386.121,186.99z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "rgb(255, 195, 189)"
    },
    d: "M365.659,169.45c0.28,5.354,0.849,15.392,5.297,17.937c0,0-2.769,5.275-8.76,5.811 c-4.531,0.406-4.23-4.063-4.23-4.063c2.621-1.959,1.992-5.268-0.003-8.999L365.659,169.45z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M362.523,173.809l-4.556,6.321c0.476,0.882,0.901,1.791,1.201,2.701 c2.107-0.842,4.509-3.956,4.167-6.291C363.165,175.375,362.842,174.294,362.523,173.809z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M346.161,158.685c-0.874,2.775-0.395,8.477,3.483,6.623S347.663,153.915,346.161,158.685z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "rgb(255, 195, 189)"
    },
    d: "M366.159,162.435c0.426,7.133,1.04,11.29-2.105,15.327c-4.73,6.072-13.893,3.807-16.449-3.075 c-2.301-6.195-2.611-16.819,3.998-20.415C358.115,150.729,365.733,155.302,366.159,162.435z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M361.158,158.557v-7.969c0,0,8.482-0.63,8.105,3.711c4.698,2.33,2.477,9.639-3.833,13.223 c-3.458-2.768-3.063-9.434-3.063-9.434C361.994,158.253,361.584,158.408,361.158,158.557z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "rgb(255, 195, 189)"
    },
    d: "M369.61,168.005c-0.344,1.892-1.535,3.441-2.854,4.309c-1.985,1.306-3.721-0.299-3.792-2.554 c-0.064-2.03,0.892-5.155,3.184-5.557C368.405,163.808,370.004,165.842,369.61,168.005z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M355.626,165.619c0.07,0.577-0.179,1.079-0.557,1.121c-0.378,0.042-0.741-0.391-0.812-0.968 c-0.07-0.577,0.179-1.079,0.557-1.121C355.192,164.609,355.556,165.042,355.626,165.619z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M349.089,166.349c0.07,0.577-0.179,1.079-0.557,1.121c-0.378,0.042-0.741-0.391-0.812-0.968 c-0.07-0.577,0.179-1.079,0.557-1.121C348.655,165.339,349.018,165.772,349.089,166.349z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DE5753"
    },
    d: "M351.202,166.404c0,0-0.958,3.354-2.23,5.073c1.119,0.788,2.805,0.157,2.805,0.157 L351.202,166.404z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M355.145,173.494c-0.233,0.059-0.482,0.104-0.747,0.134c-0.094,0.01-0.179-0.057-0.19-0.15 c-0.012-0.094,0.058-0.178,0.149-0.188c2.54-0.287,3.508-2.185,3.518-2.204c0.041-0.084,0.145-0.117,0.229-0.076 c0.085,0.042,0.12,0.145,0.078,0.229C358.144,171.315,357.309,172.953,355.145,173.494z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M357.385,163.288c-0.115,0.029-0.243-0.003-0.332-0.096c-1.061-1.102-2.301-0.89-2.314-0.888 c-0.186,0.034-0.365-0.089-0.401-0.273c-0.036-0.185,0.087-0.363,0.271-0.397c0.065-0.012,1.62-0.279,2.936,1.089 c0.131,0.137,0.128,0.352-0.008,0.482C357.493,163.247,357.44,163.274,357.385,163.288z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M345.999,164.421c-0.063,0.016-0.131,0.014-0.197-0.009c-0.179-0.063-0.274-0.258-0.212-0.435 c0.617-1.781,2.142-2.154,2.208-2.18c0.183-0.044,0.369,0.069,0.415,0.251c0.046,0.182-0.064,0.365-0.246,0.411 c-0.064,0.013-1.236,0.316-1.731,1.745C346.198,164.316,346.106,164.394,345.999,164.421z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M364.924,161.517c0,0-4.972-1.823-7.283-4.724c0,0-4.538,1.187-5.468,3.033 c0,0-1.574-1.319-0.395-3.033c0,0-3.396,0.717-4.07,3.033c0,0-1.695-0.581-1.594-3.033c0,0-1.514,0.57-1.992,3.033 c0,0-3.756-7.813,8.633-10.055c0,0-0.978-0.412-2.902-0.495c0,0,8.642-3.487,15.499-0.293 C372.21,152.178,370.957,158.31,364.924,161.517z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ef233c"
    },
    d: "M396.003,255.984l-11.99,1.6c0,0-4.95-34.59-7.13-45.76v-23.86l6.27-1.65l4.83,1.65 c1.16,3.87,2.18,8.95,3.07,14.6c0.59,3.74,1.12,7.74,1.59,11.79c0.65,5.52,1.19,11.14,1.65,16.4c0.72,8.49,1.2,16.01,1.46,20.59 C395.923,254.264,396.003,255.984,396.003,255.984z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ef233c"
    },
    d: "M376.884,211.821c0,0,0.996-16.828,6.271-25.51c0,0-0.132-2.484-1.187-2.88 c-1.055-0.396-5.084,1.978-5.084,1.978s-2.512-1.714-3.065-0.923S371.931,190.629,376.884,211.821z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.7,
      fill: "#FFFFFF"
    },
    d: "M376.884,211.821c0,0,0.996-16.828,6.271-25.51c0,0-0.132-2.484-1.187-2.88 c-1.055-0.396-5.084,1.978-5.084,1.978s-2.512-1.714-3.065-0.923S371.931,190.629,376.884,211.821z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ef233c"
    },
    d: "M349.598,260.615l1.37,0.99c0,0-1.98-11.154-1.18-39.354c0.04-1.36,0.09-2.67,0.14-3.92 c1.02-23.86,4.72-28.2,4.96-28.46l-3.46,1.18l-6.27,2.16C343.308,213.571,349.598,260.615,349.598,260.615z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ef233c"
    },
    d: "M350.141,214.226c0,0-3.463-16.354-2.433-21.992c1.029-5.638,4.722-3.133,4.722-3.133 s3.393-2.738,4.4,0.279C356.829,189.381,352.173,192.661,350.141,214.226z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.7,
      fill: "#FFFFFF"
    },
    d: "M350.141,214.226c0,0-3.463-16.354-2.433-21.992c1.029-5.638,4.722-3.133,4.722-3.133 s3.393-2.738,4.4,0.279C356.829,189.381,352.173,192.661,350.141,214.226z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M392.643,214.354c-5.12-2.87-5.8-10.36-5.8-10.36c0.31-0.12,2.21-0.77,4.21-1.43 C391.643,206.304,392.173,210.304,392.643,214.354z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M367.598,311.561l4.31-23.45l-0.83-12.41C371.078,275.701,365.168,297.221,367.598,311.561z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M395.753,251.344c-3.22-0.22-6.01-0.43-6.01-0.43l-0.61-13.09c0,0,1.04-0.87,3.37-0.62 c0,0,1.05-2.56,1.79-6.45C395.013,239.244,395.493,246.764,395.753,251.344z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(255, 195, 189)"
    },
    points: "396.852,230.741 390.582,240.809 395.541,243.66 401.432,234.588  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ef233c"
    },
    d: "M387.733,187.838c4.222,0.464,22.156,25.081,22.947,32.503 c0.791,7.421-10.535,20.231-10.535,20.231l-7.569-4.453c0,0,7.686-11.81,8.082-14.962s-14.047-16.074-14.047-16.074 s-1.577-3.796-1.777-9.26C384.633,190.359,387.733,187.838,387.733,187.838z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ef233c"
    },
    d: "M389.128,237.826c0,0,6.455,1.385,9.048,5.439c0,0-2.694,8.45-4.622,9.37 c-1.927,0.92-6.716,0.92-6.716,0.92S386.531,244.156,389.128,237.826z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegisterImg);
export default __webpack_public_path__ + "static/media/registerImg.af825511b58d20f06615a2a034a66cd7.svg";
export { ForwardRef as ReactComponent };